export const FAKE_OPPORTUNITY = {
	id: 123,
	name: 'Annual Toronto International Brazilfest',
	timeframe_start_on: '2022-07-24',
	timeframe_end_on: '2022-07-26',
	frequency: 'Annually',
	description:
		'Sponsorship is a great way to increase your corporate visibility. We have a wide variety of sponsorship packages available. We will be pleased to discuss a customized sponsorship packages that will meet your specific requirements\r\n\r\n',
	key_benefits: 'Exposure, diversity, untapped markets',
	primary_age_group: '25-30 years old',
	secondary_age_group: '31-40 years old',
	gender: 'Female',
	household_income: '$100001 - $150000',
	expected_audience: 1000,
	expected_impressions: 40000,
	reply_date: '2021-12-21',
	submission_date: '2021-12-31',
	suggested_bid: 10000,
	header_media:
		'https://sponsorcircle.com/wp-content/uploads/2021/02/sponsor-circle-black-transparent-1.png',
	body_media_1:
		'https://sponsorcircle.com/wp-content/uploads/2021/02/sponsor-circle-black-transparent-1.png',
	body_media_2: 'https://www.youtube.com/watch?v=YS4e4q9oBaU',
	sponsorship_deck:
		'https://sponsorcircle.com/wp-content/uploads/2021/02/sponsor-circle-black-transparent-1.png',
	published: true,
	property_info_id: 427,
	opportunity_types: [
		{
			id: 1,
			name: 'Podcast',
		},
		{
			id: 2,
			name: 'Event',
		},
	],
	opportunity_locations: [
		{
			id: 1,
			location: 'Toronto',
		},
		{
			id: 5,
			location: 'Bizmark',
		},
	],
	opportunity_hashtags: [
		{
			id: 4,
			name: '#flashsale',
		},
		{
			id: 73,
			name: '#brazilfest',
		},
	],
};
